import { type TableModelFiles } from "~/types/supervisor-types";

import { errorMessageHandler, http } from "./api.services";

export const getWorklistDetails = async (from: string, to: string) => {
  try {
    const data = await http
      .get(
        process.env
          .VITE_AWS_WORKLIST_DETAILS!.replace("{from}", from)!
          .replace("{to}", to),
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getWorklistTATFilters = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_WORKLIST_TAT_FILTERS!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);

    return { status: false, error: e };
  }
};
export const getWorklistCounters = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_WORKLIST_COUNTERS!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);

    return { status: false, error: e };
  }
};
export const getUserMaster = async (masterType: string) => {
  try {
    const data = await http
      .get(
        process.env.VITE_AWS_USER_MASTER!.replace("{masterType}", masterType),
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
        }
      )
      .json();

    return { status: true, data: data as any };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getUserDetails = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_USER_DETAILS!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

// use below APIS for master - start

export const getMasterDetails = async (masterName: string) => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_MASTER!.replace("{masterName}", masterName), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const editMasterDetails = async <T>(body: object, id: number, masterName: string) => {
  try {
    const data = await http
      .put(
        process.env.VITE_AWS_MASTER_BY_ID!
          .replace("{id}", id.toString())
          .replace("{masterName}", masterName),
        {
          json: { ...body },

          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
        }
      )
      .json();

    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const deleteMasterDetails = async (userId: string, masterName: string) => {
  try {
    const data = await http
      .delete(process.env.VITE_AWS_MASTER_BY_ID!
        .replace("{id}", userId)
        .replace("{masterName}", masterName), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const addMasterDetails = async <T>(body: object, masterName: string) => {
  try {
    const data = await http
      .post(process.env.VITE_AWS_MASTER!
        .replace("{masterName}", masterName), {
        json: { ...body },

        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

type CustomerMasterParams = {
  searchstring?: string;
  orderbycol: string;
  orderdirection?: "ASC" | "DESC";
  startrowindex?: number;
  maximumrows?: number;
  gettotal?: boolean;
};

export const getCustomerMaster = async (pars: CustomerMasterParams, masterName: string) => {
  try {
    const url = process.env.VITE_AWS_MASTER!;

    const params = new URLSearchParams();

    // params.set("master_name", "historical_master_shipper");
    params.set("searchstring", pars.searchstring ?? "");
    params.set("orderbycol", pars.orderbycol);
    params.set("orderdirection", pars.orderdirection ?? "ASC");
    params.set("startrowindex", pars.startrowindex?.toString() ?? "0");
    params.set("maximumrows", pars.maximumrows?.toString() ?? "10");
    params.set("gettotal", pars.gettotal?.toString() ?? "true");

    const separator = url.includes("?") ? "&" : "?";
    const finalUrl = `${url}${separator}${params.toString()}`;

    const data = await http
      .get(finalUrl.replace("{masterName}", masterName ), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as any };
  } catch (e) {
    console.error("getCustomerMaster error:", e);
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const deleteCustomer = async (
  customerIds: string[] | number[]
) => {
  try {
    const url = process.env.VITE_AWS_MASTER!;

    const data = await http
      .delete(url, {
        json: {
          customerids: customerIds,
        },
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as any };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const addCustomer = async (body: object, masterName: string) => {
  try {
    const url = process.env.VITE_AWS_MASTER!;

    const data = await http
      .post(url.replace("{masterName}", masterName), {
        json: { ...body },
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return {
      status: true,
      data: data as any,
    };
  } catch (e) {
    await errorMessageHandler(e);

    return {
      status: false,
      error: e,
    };
  }
};
export const updateCustomer = async (body: object, id: string, masterName: string) => {
  try {
    const url = process.env.VITE_AWS_MASTER_BY_ID!;

    const data = await http
      .put(url.replace("{masterName}", masterName)
      .replace("{id}", id.toString())
      , {
        json: { ...body },
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return {
      status: true,
      data: data as any,
    };
  } catch (e) {
    await errorMessageHandler(e);

    return {
      status: false,
      error: e,
    };
  }
};


// APIS for master - ends

export const getReasonCodeDetails = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_REASON_CODE_DETAILS!, {
        headers: {
          "Content-Type": "application/json",
          // "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const addUser = async <T>(body: object) => {
  try {
    const data = await http
      .post(process.env.VITE_AWS_ADD_USER!, {
        json: { ...body },

        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const EditUser = async <T>(body: object, userId: string) => {
  try {
    const data = await http
      .put(process.env.VITE_AWS_USER_BY_ID!.replace("{id}", userId), {
        json: { ...body },

        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const userById = async (userId: string) => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_USER_BY_ID!.replace("{id}", userId), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const deleteUser = async (userId: string) => {
  try {
    const data = await http
      .delete(process.env.VITE_AWS_DELETE_USER!.replace("{id}", userId), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getAllTemplates = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_GET_ALL_TEMPLATES!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const deleteTemplates = async (modelId: string) => {
  try {
    const data = await http
      .delete(process.env.VITE_AWS_DELETE_TEMPLATES!.replace("{id}", modelId), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const editTemplate = async (id: string, body: any) => {
  try {
    const data = await http
      .put(process.env.VITE_AWS_GET_TEMPLATE!.replace("{id}", id), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
        json: { ...body },
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const deleteTemplatesList = async (body: any) => {
  try {
    const data = await http
      .delete(process.env.VITE_AWS_DELETE_TEMPLATES_LIST!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
        json: { ...body },
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const addTemplate = async (body: any) => {
  try {
    const data = await http
      .post(process.env.VITE_AWS_ADD_TEMPLATE!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
        json: { ...body },
        timeout: 30000,
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getTemplateById = async (templateId: string) => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_GET_TEMPLATE!.replace("{id}", templateId), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getTemplateModelFiles = async (modelId: string) => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_GET_MODEL_FILES!.replace("{id}", modelId), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const saveTemplateDetails = async (
  body: object,
  templateId?: string
) => {
  try {
    console.log(body, templateId);
    const url =
      templateId != null
        ? process.env.VITE_AWS_POST_TEMPLATE_DETAILS!.replace(
          "{id}",
          templateId
        )
        : process.env.VITE_AWS_POST_TEMPLATE_DETAILS!;
    const data = await http
      .put(url, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
        json: { ...body },
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getTemplateTableFiles = async (modelId: string) => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_GET_TABLE_FILES!.replace("{id}", modelId), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .json();
    return { status: true, data: data as TableModelFiles };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const saveTableTemplate = async (body: object, templateId?: string) => {
  try {
    const url =
      templateId != null
        ? process.env.VITE_AWS_POST_TEMPLATE_TABLE_DETAILS!.replace(
          "{id}",
          templateId
        )
        : process.env.VITE_AWS_POST_TEMPLATE_TABLE_DETAILS!;
    const data = await http
      .put(url, {
        headers: {
          "Content-Type": "application/json",
        },
        json: { ...body },
      })
      .json();
    return { status: true, data: data as TableModelFiles };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getReports = async (query: string) => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_REPORTS!.replace("{query}", query), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as any };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getExtraction = async (from: string, to: string) => {
  try {
    const data = await http
      .get(
        process.env
          .VITE_AWS_GET_TEST_EXTRACTIONS!.replace("{from}", from)!
          .replace("{to}", to),
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const addExtraction = async (fileName: string, fileContent: string) => {
  try {
    const response = await http.post(
      process.env.VITE_AWS_ADD_TEST_EXTRACTIONS!,
      {
        body: JSON.stringify({
          file_name: fileName,
          file_content: fileContent,
        }),
        headers: {
          "Content-Type": "image/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      }
    );

    if (response.ok) {
      // Adjust based on your HTTP library's success check
      return { status: true };
    } else {
      // Read the response body to get error details
      const errorBody = await response.text();
      return { status: false, error: errorBody };
    }
  } catch (e: any) {
    return { status: false, error: e.message };
  }
};

export const addExtractionZip = async (fileName: string, fileContent: string) => {
  try {
    const response = await http.post(
      process.env.VITE_AWS_ADD_TEST_EXTRACTIONS_ZIP!,
      {
        body: JSON.stringify({
          file_name: fileName,
          file_content: fileContent,
        }),
        headers: {
          "Content-Type": "image/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      }
    );

    if (response.ok) {
      // Adjust based on your HTTP library's success check
      return { status: true };
    } else {
      // Read the response body to get error details
      const errorBody = await response.text();
      return { status: false, error: errorBody };
    }
  } catch (e: any) {
    return { status: false, error: e.message };
  }
};

export const reloadExtraction = async (taskId: string) => {
  try {
    const data = await http
      .put(
        process.env.VITE_AWS_RELOAD_TEST_EXTRACTIONS!.replace("{id}", taskId),
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getAHTMonitoring = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_GET_AHT_Report!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_AWS_GET_AHT_Report_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const deleteReasonCode = async (Id: string) => {
  try {
    const data = await http
      .delete(process.env.VITE_AWS_DELETE_REASON_CODE!.replace("{id}", Id), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const getReasonCodeById = async (Id: number) => {
  try {
    const data = await http
      .get(
        process.env.VITE_AWS_GET_REASON_CODE_BY_ID!.replace(
          "{id}",
          Id.toString()
        ),
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const addReasonCode = async <T>(body: object) => {
  try {
    const data = await http
      .post(process.env.VITE_AWS_ADD_REASON_CODE!, {
        json: { ...body },

        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const EditReasonCode = async <T>(body: object, id: number) => {
  try {
    const data = await http
      .put(
        process.env.VITE_AWS_EDIT_REASON_CODE!.replace("{id}", id.toString()),
        {
          json: { ...body },

          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
        }
      )
      .json();

    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const uploadreasoncodexl = async <T>(
  fileName: string,
  fileContent: string
) => {
  try {
    console.log("Uploading reason code file:", fileName);
    console.log("File content (truncated):", fileContent);
    const data = await http
      .post(process.env.VITE_AWS_UPLOAD_REASON_CODE!, {
        body: JSON.stringify({
          file_name: fileName,
          file_content: fileContent,
        }),
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getDocumentTypes = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_DOCUMENTTYPES!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as any };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

// Exception Dashboard
export const getExceptionList = async (from?: string, to?: string) => {
  try {
    // Set default values if 'from' or 'to' are undefined
    const fromDate = from ?? ""; //!.replace with appropriate default value
    const toDate = to ?? ""; //!.replace with appropriate default value

    const data = await http
      .get(
        process.env
          .VITE_AWS_EXCEPTION_LIST!.replace("{from}", fromDate)!
          .replace("{to}", toDate),
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

// Allocation Modal APIs
export const getAllAgentDetails = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_ALLOCATION_AGENT!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getAllAgentGroupDetails = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_ALLOCATION_GROUP!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const assignTask = async <T>(body?: object) => {
  try {
    const data = await http
      .post(process.env.VITE_AWS_MANUAL_ALLOCATION!, {
        json: { ...body },

        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

//Put Tasks on hold and Recieved status
export const EditTaskStatus = async <T>(body: object, status: string) => {
  try {
    const data = await http
      .put(
        process.env.VITE_AWS_WORKLISTTASKSTATUS_BY_ID!.replace(
          "{status}",
          status
        ),
        {
          json: body,

          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
        }
      )
      .json();

    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const TGESMETaskLockResponse = async (
  taskId: string,
  roleid: string
) => {
  let response;
  try {
    // const url = new URL(
    //   `${process.env.VITE_CHECK_LOCK_API_URL!.replace("{taskid}", taskId)}`
    // );

    // url.searchParams.append("roleid", roleid);
    response = await http
      .put(
        `${process.env.VITE_CHECK_LOCK_API_URL!.replace("{taskid}", taskId)}?roleid=${roleid}`.toString(),
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
        }
      )
      .json();

    return { response: response, error: null };
  } catch (e) {
    await errorMessageHandler(e);

    return { error: e, response: null };
  }
};

type MenuType = "admin" | "supervisor" | "client" | "businessRules" | "analyst";

const MENU_ENDPOINTS: Record<MenuType, string | undefined> = {
  admin: process.env.VITE_AWS_ADMIN_MENU_ITEMS,
  supervisor: process.env.VITE_AWS_SUPERVISOR_MENU_ITEMS,
  client: process.env.VITE_AWS_CLIENT_MENU_ITEMS,
  businessRules: process.env.VITE_AWS_BUSINESS_RULE_MENU_ITEMS,
  analyst: process.env.VITE_AWS_ANALYST_MENU_ITEMS,
};

export const getMenuItems = async (menuType: MenuType, masterType: string) => {
  const cacheKey = `${masterType}`;
  const cached = sessionStorage.getItem(cacheKey);

  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      return { status: true, data: parsed };
    } catch (error) {
      console.warn(`Invalid JSON in cache for key ${cacheKey}`, error);
      sessionStorage.removeItem(cacheKey); // Clean bad cache
    }
  }

  const endpointTemplate = MENU_ENDPOINTS[menuType];
  const apiKey = process.env.VITE_BASE_API_KEY;

  if (!endpointTemplate) {
    console.warn(`Missing API endpoint for ${menuType}`);
    return { status: false, error: "Missing configuration" };
  }

  const url = endpointTemplate.replace("{masterType}", masterType);

  try {
    const data = await http
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
      })
      .json();

    sessionStorage.setItem(cacheKey, JSON.stringify(data));
    return { status: true, data };
  } catch (e: any) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const saveLogs = async (
  roleId: string,
  payload: { taskid: string; message: string }
) => {
  try {
    const url = process.env.VITE_SAVE_LOGS!.replace("{roleid}", roleId);
    const data = await http
      .post(url, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
        json: JSON.stringify(payload),
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getAdminMenuItems = (masterType: string) =>
  getMenuItems("admin", masterType);

export const getSupervisorMenuItems = (masterType: string) =>
  getMenuItems("supervisor", masterType);

export const getClientMenuItems = (masterType: string) =>
  getMenuItems("client", masterType);

export const getBusinessRulesMenuItems = (masterType: string) =>
  getMenuItems("businessRules", masterType);

export const getAnalystMenuItems = (masterType: string) =>
  getMenuItems("analyst", masterType);
